export const aboutData = {
    title: "Engineering that ships, from APIs to vision models.",
    paragraphs: [
        "I'm a Senior Software Engineer based in Addis Ababa, Ethiopia. I hold a B.Sc. in Software Engineering from Jimma University and work at the Ethiopian Artificial Intelligence Institute, where most of my work is full-stack development, alongside computer vision and machine learning.",
        "My day-to-day spans the whole stack: Django REST Framework or Node.js and Express services behind PostgreSQL, React and Next.js interfaces in front, Docker and Kubernetes for deployment, Redis for real-time messaging, and machine learning where the product calls for it. I like designing systems as small, well-defined services and solving real problems with them.",
    ],
    focus: [
        {
            title: 'Backend & microservices',
            text: 'APIs and service-oriented systems, containerized and connected with Redis pub/sub.',
            tags: ['Django REST Framework', 'Node.js', 'Express.js', 'PostgreSQL', 'Docker', 'Kubernetes'],
        },
        {
            title: 'Frontend engineering',
            text: 'Responsive, typed interfaces that stay maintainable as products grow.',
            tags: ['React.js', 'Next.js', 'TypeScript', 'Tailwind CSS'],
        },
        {
            title: 'Computer vision & ML',
            text: 'Machine learning and computer vision applied inside real products.',
            tags: ['Computer Vision', 'Machine Learning', 'AI applications'],
        },
    ],
}
